<template>
  <v-container>
    <!-- ここからがチャート部分 -->
    <apexchart
      type="radar"
      height="950"
      :options="chartOptions"
      :series="series"
    />
  </v-container>
</template>

<script>
export default {
  chart() {
    return {
      series: [
        { name: '件数', data: [10, 41, 35, 51, 49] }
      ],
      chartOptions: {
        title: {text: '都道府県別件数', align: 'center'},
        subtitle: {text: '2026年2月データ',align: 'center' },
        chart: { toolbar: { show: true } },
        xaxis: { categories: ['Tokyo', 'Osaka', 'Kyoto', 'Aichi', 'Fukuoka'] }
      }
    }
  }
}
</script>
